import React, { useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Markdown from 'react-markdown';
import { Container, Row, Col } from "react-bootstrap";

import api from "@/services/api";

import Breadcrumbs from "@Elements/Breadcrumbs/Breadcrumbs";

import "@Styles/_static-page.sass";

const Regulations = () => {

	const currentLang = useSelector((state) => state.app.currentLang);
	const { t } = useTranslation();

	const [ staticText, setStaticText ] = useState(null);

	useEffect(() => {
		api.get('/static-files/accessibility-statement')
			.then(response => {
				setStaticText(response.data);
			});
	}, []);

	const breadcrumbsList = [
		{ label: "home", id: 1 },
		{ label:t('staticPage.accessibilityStatement') , id: 2 },
	];

	return (
		<main className='static-page'>
			<Container>
				<Breadcrumbs breadcrumbsList={ breadcrumbsList } />
				<section className='static-page__content'>
					<Row>
						<Col>
							{ staticText &&
								<Markdown>{ staticText[currentLang] }</Markdown> }
						</Col>
					</Row>
				</section>
			</Container>
		</main>
	);
};

export default Regulations;